import type { FormLookup } from "../types.js";

import ContactCoPackingEN from "./ContactCoPackingEN.js";
import ContactCoPackingFR from "./ContactCoPackingFR.js";
import ContactCreativeEN from "./ContactCreativeEN.js";
import ContactCreativeFR from "./ContactCreativeFR.js";
import ContactEN from "./ContactEN.js";
import ContactFR from "./ContactFR.js";
import ContactSalesEN from "./ContactSalesEN.js";
import ContactSalesFR from "./ContactSalesFR.js";
import DielineRequestEN from "./DielineRequestEN.js";
import DielineRequestFR from "./DielineRequestFR.js";
import KeepInTouch from "./KeepInTouch.js";
import NewsletterSignup from "./NewsletterSignup.js";
import NewsletterSignupFR from "./NewsletterSignupFR.js";
import Preferences from "./Preferences.js";

export const formLookup: FormLookup = {
	KeepInTouch,
	NewsletterSignup,
	NewsletterSignupFR,
	Preferences,
	ContactEN,
	ContactFR,
	ContactCreativeEN,
	ContactCreativeFR,
	ContactCoPackingEN,
	ContactCoPackingFR,
	ContactSalesEN,
	ContactSalesFR,
	DielineRequestEN,
	DielineRequestFR,
};
